<dx-data-grid [dataSource]="items"
              [allowColumnResizing]="allowHeaderActions"
              [allowColumnReordering]="allowHeaderActions"
              [columnAutoWidth]="true"
              [wordWrapEnabled]="true"
              [rowAlternationEnabled]="true"
              [hoverStateEnabled]="true"
              [showRowLines]="true"
              [showBorders]="true"
              noDataText="No items matching the filter criteria were found"
              [stateStoring]="dxGridWrapperHelper.stateStoringOptions"
              (onInitialized)="onGridInitialized($event)"
              (onContentReady)="onGridContentReady($event)"
              (onSelectionChanged)="onSelectionChanged($event)">
    <dxo-data-grid-column-chooser [enabled]="allowHeaderActions"></dxo-data-grid-column-chooser>
    <dxo-data-grid-paging [pageSize]="10"></dxo-data-grid-paging>
    <dxo-data-grid-pager [showPageSizeSelector]="true"
                         [allowedPageSizes]="[10, 25, 50, 100]"></dxo-data-grid-pager>
    <dxo-data-grid-filter-row [visible]="true"></dxo-data-grid-filter-row>
    <dxo-data-grid-header-filter [visible]="true"></dxo-data-grid-header-filter>
    <dxo-data-grid-group-panel [visible]="allowHeaderActions"></dxo-data-grid-group-panel>
    <dxo-data-grid-grouping [autoExpandAll]="true"></dxo-data-grid-grouping>
    <dxo-data-grid-export [enabled]="allowHeaderActions"
                          fileName="Actions"></dxo-data-grid-export>
    @if (!allowHeaderActions) {
        <dxo-data-grid-sorting mode="none"></dxo-data-grid-sorting>
    }
    <dxo-data-grid-load-panel [enabled]="true"></dxo-data-grid-load-panel>
    @if (allowSelection) {
        <dxo-data-grid-selection [mode]="allowMultipleSelection ? 'multiple' : 'single'"
                                 showCheckBoxesMode="onClick"></dxo-data-grid-selection>
    }

    <dxi-data-grid-column caption="Person"
                          cellTemplate="personCellTemplate"
                          groupCellTemplate="personGroupCellTemplate"
                          dataField="assignee.fullName"
                          dataType="string"
                          alignment="left"
                          [width]="150"></dxi-data-grid-column>

    <dxi-data-grid-column caption="Item code"
                          cellTemplate="codeCellTemplate"
                          dataField="code"
                          dataType="string"
                          alignment="left"
                          [width]="100">
        <dxo-data-grid-header-filter [dataSource]="codeHeaderItems"></dxo-data-grid-header-filter>
    </dxi-data-grid-column>

    <dxi-data-grid-column caption="Summary"
                          dataField="summary"
                          dataType="string"
                          alignment="left"
                          [allowHeaderFiltering]="false"></dxi-data-grid-column>

    <dxi-data-grid-column caption="Description"
                          cellTemplate="descriptionCellTemplate"
                          dataField="description"
                          dataType="string"
                          alignment="left"
                          [visible]="false"
                          [allowHeaderFiltering]="false"></dxi-data-grid-column>

    <dxi-data-grid-column caption="Status"
                          dataField="status"
                          dataType="string"
                          alignment="left"
                          cellTemplate="statusCellTemplate"
                          [calculateCellValue]="calculateStatusCellValue"
                          [width]="120"
                          [allowSearch]="false">
        <dxo-data-grid-header-filter [dataSource]="statusHeaderItems"></dxo-data-grid-header-filter>
    </dxi-data-grid-column>

    <dxi-data-grid-column caption="Team"
                          cellTemplate="teamCellTemplate"
                          dataField="board.team.name"
                          dataType="string"
                          alignment="left"
                          [width]="100"></dxi-data-grid-column>

    <dxi-data-grid-column dataField="createdDateTime"
                          dataType="date"
                          caption="Date created"
                          [format]="dateFormat"
                          sortOrder="desc"
                          alignment="left"
                          [visible]="false"
                          [width]="160"></dxi-data-grid-column>

    <dxi-data-grid-column dataField="lastUpdatedDateTime"
                          dataType="date"
                          caption="Date last updated"
                          [format]="dateFormat"
                          alignment="left"
                          [visible]="false"
                          [width]="160"></dxi-data-grid-column>

    <dxi-data-grid-column dataField="dueDate"
                          dataType="date"
                          caption="Date due"
                          [format]="dateFormat"
                          alignment="left"
                          [visible]="false"
                          [width]="160"></dxi-data-grid-column>

    <div *dxTemplate="let cellItem of 'personCellTemplate'">
        @if (asItem(cellItem.data); as item) {
            <adapt-link-person [person]="item.assignee"
                               [showImage]="true"
                               imageSize="xs"
                               nullValueText="Unassigned"></adapt-link-person>
        }
    </div>
    <div *dxTemplate="let item of 'personGroupCellTemplate'">
        <div>Person: {{ item.value ?? "Unassigned" }}</div>
    </div>

    <div *dxTemplate="let cellItem of 'codeCellTemplate'">
        @if (asItem(cellItem.data); as item) {
            <adapt-item-link [item]="item"
                             [showSummary]="false"
                             [showStatus]="false"></adapt-item-link>
        }
    </div>

    <div *dxTemplate="let cellItem of 'statusCellTemplate'"
         class="d-flex">
        @if (asItem(cellItem.data); as item) {
            <adapt-display-item-status [itemStatus]="item.status"></adapt-display-item-status>
        }
    </div>

    <div *dxTemplate="let cellItem of 'descriptionCellTemplate'">
        @if (asItem(cellItem.data); as item) {
            <div [froalaView]="item.description"></div>
        }
    </div>

    <div *dxTemplate="let cellItem of 'teamCellTemplate'">
        @if (asItem(cellItem.data); as item) {
            @if (item.board?.team) {
                <adapt-link-team [team]="item.board!.team"></adapt-link-team>
            }
            @if (!item.board?.team) {
                N/A
            }
        }
    </div>
</dx-data-grid>
